import { Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { homeGuard } from './shared/guards/home.guard';
import { loginGuard } from './shared/guards/login.guard';
import { superAdminGuard } from './shared/guards/super-admin.guard';

export const routes: Routes = [
  {
    path: 'login',
    canActivate: [loginGuard],
    loadComponent: () => import('./pages/login/login.component').then(m => m.LoginComponent),
  },
  {
    path: 'forgot-password',
    canActivate: [loginGuard],
    loadComponent: () => import('./pages/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent),
  },
  {
    path: 'reset-password',
    loadComponent: () => import('./pages/reset-password/reset-password.component').then(m => m.ResetPasswordComponent),
  },
  // ── App principal (requiere login) ─────────────────────────────────────
  {
    path: '',
    component: LayoutComponent,
    canActivate: [homeGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () => import('./pages/dashboard/dashboard.component').then(m => m.DashboardComponent),
      },
      {
        path: 'mi-cuenta',
        loadComponent: () => import('./pages/mi-cuenta/mi-cuenta.component').then(m => m.MiCuentaComponent),
      },
      // ── Catálogo Webly — variantes y Design Packs ───────────────────────
      {
        path: 'backoffice/catalogo',
        canActivate: [superAdminGuard],
        children: [
          { path: '', pathMatch: 'full', redirectTo: 'componentes' },
          {
            path: 'componentes',
            loadComponent: () => import('./pages/backoffice/catalogo/componentes/componentes.component').then(m => m.AdminComponentesComponent),
          },
          {
            path: 'componentes/:id',
            loadComponent: () => import('./pages/backoffice/catalogo/componentes/componente-detalle/componente-detalle.component').then(m => m.ComponenteDetalleComponent),
          },
          {
            path: 'packs',
            loadComponent: () => import('./pages/backoffice/catalogo/packs/packs.component').then(m => m.AdminPacksComponent),
          },
          {
            path: 'packs/:id',
            loadComponent: () => import('./pages/backoffice/catalogo/packs/pack-detalle/pack-detalle.component').then(m => m.PackDetalleComponent),
          },
        ],
      },
      {
        path: 'backoffice/ordenes-compra',
        canActivate: [superAdminGuard],
        loadComponent: () => import('./pages/backoffice/ordenes-compra/ordenes-compra.component').then(m => m.OrdenesCompraComponent),
      },
      {
        path: 'backoffice/soluciones',
        canActivate: [superAdminGuard],
        loadComponent: () => import('./pages/backoffice/soluciones/soluciones.component').then(m => m.SolucionesComponent),
      },
      {
        path: 'backoffice/soluciones/:code',
        canActivate: [superAdminGuard],
        loadComponent: () => import('./pages/backoffice/soluciones/solucion-detalle/solucion-detalle.component').then(m => m.SolucionDetalleComponent),
      },
      {
        path: 'backoffice/planes',
        redirectTo: 'backoffice/soluciones',
        pathMatch: 'full',
      },
      {
        path: 'backoffice/complementos',
        redirectTo: 'backoffice/soluciones',
        pathMatch: 'full',
      },
      {
        path: 'backoffice/organizaciones',
        canActivate: [superAdminGuard],
        loadComponent: () =>
          import('./pages/backoffice/organizaciones/organizaciones.component')
            .then(m => m.OrganizacionesComponent),
      },
      {
        path: 'backoffice/organizaciones/:orgId',
        canActivate: [superAdminGuard],
        loadComponent: () =>
          import('./pages/backoffice/org-detalle/org-detalle.component')
            .then(m => m.OrgDetalleComponent),
      },
      // ── WEBLY-WEB — Webpages ─────────────────────────────────────────────
      {
        path: 'backoffice/webpages/global-templates',
        canActivate: [superAdminGuard],
        loadComponent: () =>
          import('./pages/backoffice/webpages/global-templates/global-templates.component')
            .then(m => m.GlobalTemplatesComponent),
      },
      // ── Storage ──────────────────────────────────────────────────────────
      {
        path: 'backoffice/storage/integraciones',
        canActivate: [superAdminGuard],
        loadComponent: () =>
          import('./pages/backoffice/storage/integraciones/integraciones.component')
            .then(m => m.IntegracionesComponent),
      },
      {
        path: 'backoffice/storage/integraciones/:id',
        canActivate: [superAdminGuard],
        loadComponent: () =>
          import('./pages/backoffice/storage/integracion-detalle/integracion-detalle.component')
            .then(m => m.IntegracionDetalleComponent),
      },
      {
        path: 'backoffice/storage/system-config',
        canActivate: [superAdminGuard],
        loadComponent: () =>
          import('./pages/backoffice/system-config/system-config.component')
            .then(m => m.SystemConfigComponent),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
